// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1mut6","insightsList":"newBusinessInsightsMenu_insightsList__1bJaq","active":"newBusinessInsightsMenu_active__WV4v3"};